import React from 'react';

import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from 'styled-components';

import { MenuItemHeader } from 'components/Layout/Header/components/MegaMenuItem/megamenu-item.styles';

import MenuItemSubHeader from 'components/Layout/Header/components/MegaMenuItem/components/MegaMenuItemBody/components/MenuItemSubHeader';
import Link from 'components/Link';

import { MenuColumnSubMenuItemI } from 'interfaces/content-stack/contentStack.types';

import { getModularBlockLink } from 'utils/modularBlockUtils';

export const MegaMenuContentLink = styled(Link)`
  display: block;
  padding: 1rem;
  text-decoration: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors.black};
  transition: background-color 0.2s linear;
  max-width: 22.5rem;

  &:hover {
    background-color: ${(props) => props.theme.colors.hoverLightGray};
  }
`;

interface MegaMenuBodyContentLinksProps {
  contentLinks: MenuColumnSubMenuItemI;
}

const MegaMenuItemBodyContentLinks = ({ contentLinks }: MegaMenuBodyContentLinksProps) => {
  const { linkText, snippet, link } = contentLinks;
  const url = getModularBlockLink(link);

  return (
    <>
      <MegaMenuContentLink to={url} data-testid='desktop-navbar-item'>
        {linkText && (
          <MenuItemHeader>
            {linkText}&nbsp;
            <FontAwesomeIcon icon={faChevronRight} size='xs' />
          </MenuItemHeader>
        )}
        {snippet && <MenuItemSubHeader richText={snippet} />}
      </MegaMenuContentLink>
    </>
  );
};

export default MegaMenuItemBodyContentLinks;
